import PropTypes from 'prop-types';
import React from 'react';
import Icon from '@jd/jmtd/es/Icon';
import Modal from '@jd/jmtd/es/Modal';
import ModalHeader from '@jd/jmtd/es/ModalHeader';
import ModalSection from '@jd/jmtd/es/ModalSection';
import Popover from '@jd/jmtd/es/Popover';
import Table from '@jd/jmtd/es/Table';
import { addDate, formatDate } from '@jd/jmtd-tools/dist/date';
import { findYOY } from '@jd/jmtd-tools/es/lunar';


import Tabs from '@jd/jmtd/es/Tabs';
import FormControlButton from '@jd/jmtd/es/FormControlButton';

function parseTime(d, t) {
    const [Y, M, D] = d.split('-').map(x => parseInt(x, 10));
    const [h, m, s] = t.split(':').map(x => parseInt(x, 10));
    return new Date(Y, M - 1, D, h, m, s);
}

function parseTimeStr(str) {
    return parseTime(...str.split(' '));
}

function ImageDescription({
    rangeStart,
    rangeEnd,
    start,
    end,
    compareStart,
    compareEnd,
    children,
    background,
}) {
    return (
        <div
            className='jmtp-ge-realtime-compare-time-group-image-description'
            style={{
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            <div
                style={{
                    marginTop: 15,
                    height: 175,
                    backgroundImage: `url(${background})`,
                    backgroundSize: '100% 100%',
                }}
            ></div>
            <div
                style={{
                    position: 'absolute',
                    top: 10,
                    left: 18,
                    color: 'rgba(0,0,0,0.9)',
                    fontSize: 14,
                    display: 'flex',
                    height: 14,
                    alignItems: 'center',
                }}
            >
                <Icon className='jmti-clock' />
                {rangeStart} 至 {rangeEnd}
            </div>
            <div
                style={{
                    position: 'absolute',
                    left: 18,
                    top: 71,
                    fontSize: 12,
                    lineHeight: '17px',
                    color: '#FF8C19',
                }}
            >
                统计数据时间范围
                <br />
                {start} 至 {end}
            </div>
            <div
                style={{
                    position: 'absolute',
                    left: 18,
                    top: 124,
                    fontSize: 12,
                    lineHeight: '17px',
                    color: '#2687E9',
                }}
            >
                对比数据时间范围
                <br />
                {compareStart} 至 {compareEnd}
            </div>
            {children}
        </div>
    );
}

ImageDescription.propTypes = {
    background: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    compareEnd: PropTypes.string.isRequired,
    compareStart: PropTypes.string.isRequired,
    end: PropTypes.string.isRequired,
    rangeEnd: PropTypes.string.isRequired,
    rangeStart: PropTypes.string.isRequired,
    start: PropTypes.string.isRequired,
};

function NormalCompare(props) {
    const { start, end, compareStart, compareEnd } = props;
    return (
        <ImageDescription
            {...props}
            background='https://img30.360buyimg.com/imgcloud/jfs/t1/127463/3/31849/6889/6358a63fE80a10709/3370deaf52bbfa9c.png'
        >
            <Popover
                placement='topLeft'
                trigger='control'
                open
                popover={start}
                margin={10}
                className='jmtp-ge-realtime-compare-time-group-image-description-tooltip-current'
                arrowPointAtCenter
            >
                <div
                    style={{
                        position: 'absolute',
                        left: 279,
                        top: 91,
                        width: 6,
                        height: 6,
                    }}
                ></div>
            </Popover>
            <Popover
                placement='topRight'
                trigger='control'
                open
                popover={end}
                margin={10}
                className='jmtp-ge-realtime-compare-time-group-image-description-tooltip-current'
                arrowPointAtCenter
            >
                <div
                    style={{
                        position: 'absolute',
                        left: 731,
                        top: 91,
                        width: 6,
                        height: 6,
                    }}
                ></div>
            </Popover>
            <Popover
                placement='bottomLeft'
                trigger='control'
                open
                popover={compareStart}
                margin={10}
                className='jmtp-ge-realtime-compare-time-group-image-description-tooltip-compare'
                arrowPointAtCenter
            >
                <div
                    style={{
                        position: 'absolute',
                        left: 279,
                        top: 131,
                        width: 6,
                        height: 6,
                    }}
                ></div>
            </Popover>
            <Popover
                placement='bottomRight'
                trigger='control'
                open
                popover={compareEnd}
                margin={10}
                className='jmtp-ge-realtime-compare-time-group-image-description-tooltip-compare'
                arrowPointAtCenter
            >
                <div
                    style={{
                        position: 'absolute',
                        left: 731,
                        top: 131,
                        width: 6,
                        height: 6,
                    }}
                ></div>
            </Popover>
        </ImageDescription>
    );
}

NormalCompare.propTypes = {
    compareEnd: PropTypes.string.isRequired,
    compareStart: PropTypes.string.isRequired,
    end: PropTypes.string.isRequired,
    start: PropTypes.string.isRequired,
    rangeEnd: PropTypes.string.isRequired,
    rangeStart: PropTypes.string.isRequired,
};

function AheadCompare(props) {
    const { start, end, compareStart, compareEnd } = props;
    return (
        <ImageDescription
            {...props}
            background='https://img30.360buyimg.com/imgcloud/jfs/t1/191162/16/28645/18321/6358a1f8E2732d969/e62a35682385a91a.png'
        >
            <Popover
                placement='topLeft'
                trigger='control'
                open
                popover={start}
                margin={10}
                className='jmtp-ge-realtime-compare-time-group-image-description-tooltip-current'
                arrowPointAtCenter
            >
                <div
                    style={{
                        position: 'absolute',
                        left: 279,
                        top: 91,
                        width: 6,
                        height: 6,
                    }}
                ></div>
            </Popover>
            <Popover
                placement='topLeft'
                trigger='control'
                open
                popover={end}
                margin={10}
                className='jmtp-ge-realtime-compare-time-group-image-description-tooltip-current'
                arrowPointAtCenter
            >
                <div
                    style={{
                        position: 'absolute',
                        left: 499,
                        top: 91,
                        width: 6,
                        height: 6,
                    }}
                ></div>
            </Popover>
            <Popover
                placement='bottomLeft'
                trigger='control'
                open
                popover={compareStart}
                margin={10}
                className='jmtp-ge-realtime-compare-time-group-image-description-tooltip-compare'
                arrowPointAtCenter
            >
                <div
                    style={{
                        position: 'absolute',
                        left: 391,
                        top: 132,
                        width: 6,
                        height: 6,
                    }}
                ></div>
            </Popover>
            <Popover
                placement='bottomLeft'
                trigger='control'
                open
                popover={compareEnd}
                margin={10}
                className='jmtp-ge-realtime-compare-time-group-image-description-tooltip-compare'
                arrowPointAtCenter
            >
                <div
                    style={{
                        position: 'absolute',
                        left: 624,
                        top: 132,
                        width: 6,
                        height: 6,
                    }}
                ></div>
            </Popover>
        </ImageDescription>
    );
}

AheadCompare.propTypes = {
    compareEnd: PropTypes.string.isRequired,
    compareStart: PropTypes.string.isRequired,
    end: PropTypes.string.isRequired,
    start: PropTypes.string.isRequired,
    rangeEnd: PropTypes.string.isRequired,
    rangeStart: PropTypes.string.isRequired,
};

const columns = [
    {
        title: '时间段',
        width: 350,
        dataIndex: 'segment',
    },
    { title: '对比规则', width: 410, dataIndex: 'rule' },
];

const tabsData = [
    {
        label: '规则解读',
        value: 'rule',
    },
    {
        label: '图示说明',
        value: 'image',
    },
];

export default function RuleDescription({
    operations,
    focusedOperation,
    open,
    currentTab,
    onTabChange,
    onClose,
    onOperationChange,
}) {
    if (!operations?.length) {
        return null;
    }

    // 如果没有匹配的焦点选项，默认第一个选项焦点
    if (!focusedOperation || !operations.find(o => o.label === focusedOperation.label)) {
        focusedOperation = operations[0];
    }

    let main;

    const list = focusedOperation.description();
    const getTime = t => {
        const {
            realtime,
            compareTimeKey,
            compareTime,
            compareTimeDescription = compareTime,
        } = focusedOperation.value(t);
        let start, end, compareStart, compareEnd;

        // 处理当期时间
        if (realtime.type === 'rangeDayTime') {
            [start, end] = realtime.value.map(([s, e]) => parseTime(s, e));
        } else {
            const {
                day,
                value: [st, et],
            } = realtime;
            start = parseTime(day, st);
            end = parseTime(day, et);
        }

        // 处理对比时间
        if (compareTimeDescription) {
            [compareStart, compareEnd] = compareTimeDescription.value.map(([s, e]) =>
                parseTime(s, e),
            );
        } else {
            const circle =
                compareTimeKey === 'lunarYoy' ? d => findYOY(d) : d => addDate(d, -1, 'year');

            [compareStart, compareEnd] = [start, end].map(circle);
        }

        return { start, end, compareStart, compareEnd };
    };

    const imageData = list.map(({ range, ahead }) => {
        const [rangeStart, rangeEnd] = range.map(parseTimeStr);

        return { rangeStart, rangeEnd, ahead, ...getTime(rangeEnd) };
    });

    if (currentTab === 'image') {
        main = imageData.map(
            ({ ahead, rangeStart, rangeEnd, start, end, compareStart, compareEnd }, index) => {
                [rangeStart, rangeEnd, start, end, compareStart, compareEnd] = [
                    rangeStart,
                    rangeEnd,
                    start,
                    end,
                    compareStart,
                    compareEnd,
                ].map(d => formatDate(d, 'YYYY-MM-DD hh:mm'));
                const props = {
                    rangeStart,
                    rangeEnd,
                    start,
                    end,
                    compareStart,
                    compareEnd,
                };

                if (ahead) {
                    return <AheadCompare key={index} {...props} />;
                }
                return <NormalCompare key={index} {...props} />;
            },
        );
    } else {
        const dataSource = list.map(({ range, current }) => {
            let [rangeStart, rangeEnd] = range.map(parseTimeStr);
            let { start, end, compareStart } = getTime(rangeStart);

            [rangeStart, rangeEnd, start, end, compareStart] = [
                rangeStart,
                rangeEnd,
                start,
                end,
                compareStart,
            ].map(d => {
                if (d.getMinutes() === 59) {
                    d = new Date(d);
                    d.setMinutes(60);
                }
                return formatDate(d, 'YYYY年MM月DD日hh点');
            });

            return {
                segment: `${rangeStart}~${rangeEnd}`,
                rule: `用${start}~${
                    current ? '当前时间' : end
                }的累计数据，与${compareStart}开始同时段数据进行对比`,
            };
        });
        main = <Table columns={columns} dataSource={dataSource} />;
    }

    return (
        open && (
            <Modal visible width={800} onClose={onClose} showCloseBtn>
                <ModalHeader noBorder>规则说明</ModalHeader>
                <ModalSection>
                    <div
                        className='jmtp-ge-realtime-compare-time-group-description-operations'
                        data-event-label='规则选项'
                    >
                        {operations.map((option, index) => (
                            <FormControlButton
                                outline
                                size='small'
                                key={index}
                                className='jmtp-ge-realtime-compare-time-group-description-operation'
                                checked={focusedOperation.label === option.label}
                                onClick={() => {
                                    onOperationChange(option);
                                }}
                            >
                                {option.label}
                            </FormControlButton>
                        ))}
                    </div>
                    <Tabs data={tabsData} size='small' value={currentTab} onChange={onTabChange} />
                    <div style={{ height: 20 }}></div>
                    {main}
                </ModalSection>
            </Modal>
        )
    );
}

RuleDescription.propTypes = {
    currentTab: PropTypes.string.isRequired,
    focusedOperation: PropTypes.object,
    getNow: PropTypes.func.isRequired,
    onOperationChange: PropTypes.func.isRequired,
    onTabChange: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    operations: PropTypes.array,
};

RuleDescription.defaultProps = {
    focusedOperation: null,
    operations: [],
};
